<template>
  <div class="home">
    <a-row :gutter="[8, 8]" justify="space-between" style="height: 65vh; max-height: 500px; align-items: stretch;"
           type="flex">
      <a-col :lg="14" :md="14" :sm="24" :xl="8" :xs="24" :xxl="8" style="align-self: stretch;">
        <a-spin :spinning="loading">
          <a-card style="display: flex; align-items: center; height: 100%;">
            <a-result v-if="computedSession.canLogin === undefined ? false : !computedSession.canLogin"
                      status="error" sub-title="Logowanie zostało wyłączone z powodu zbyt wielu nieudanych prób, spróbuj ponownie za 30 minut."
                      title="Logowanie zablokowane!"/>
            <a-form v-else :form="form" @submit="submit">
              <a-form-item>
                <h1 style="font-size: 3em">Zaloguj się...</h1>
                <p>Podaj dane i uzyskaj dostęp do konta</p>
              </a-form-item>
              <a-form-item v-show="step === 'FIRST_STEP'">
                <a-input ref="FIRST_STEP" v-decorator="[
                                        'personId',
                                        { rules: [{ required: true, min: 4, message: 'Uzupełnij numer PESEL lub numer paszportu!' }] },
                                    ]" :maxLength="20" placeholder="Numer PESEL lub numer paszportu">
                </a-input>
              </a-form-item>
              <a-form-item v-show="step === 'FIRST_STEP'">
                <a-row :gutter="[8, 0]">
                  <a-col :span="24" style="text-align: right;">
                    <a-button :loading="loading" style="padding-left: 1.4em; padding-right: 1.4em;"
                              type="primary" @click="submit()">
                      Dalej
                    </a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
            <a-form v-if="step !== 'FIRST_STEP'" :form="form" @submit="submit">
              <a-form-item v-if="step === 'NAME_AND_SURNAME'">
                <a-input ref="NAME_AND_SURNAME" v-decorator="[
                                        'firstName',
                                        { rules: [{ required: true, min: 1, message: 'Uzupełnij imię!' }] },
                                    ]" :maxLength="50" placeholder="Imię">
                </a-input>
              </a-form-item>
              <a-form-item v-if="step === 'NAME_AND_SURNAME'">
                <a-input v-decorator="[
                                        'lastName',
                                        { rules: [{ required: true, min: 1, message: 'Uzupełnij nazwisko!' }] },
                                    ]" :maxLength="50" placeholder="Nazwisko">
                </a-input>
              </a-form-item>
              <a-form-item v-if="step === 'CODE'">
                <h3>Kod dostępu</h3>
                <a-row :gutter="[8, 8]" style="flex-wrap: nowrap;" type="flex">
                  <template>
                    <a-col v-for="(input, index) in codeInputs" :key="index" :class="index === (codeInputs.length / 2) - 1 ? 'dash-after' : ''"
                           class="input-wrapper">
                      <a-input :ref="`CODE${index}`" v-model="input.value" :maxLength="1"
                               autocomplete="off"
                               size="large"
                               style="text-align: center;"
                               @click="focusOnClickInputCode(index)" @input="focusNextInputCode(index)"
                               @keydown="focusPreviousInputCode($event, index)"/>
                    </a-col>
                  </template>
                </a-row>
              </a-form-item>
              <a-form-item v-if="step === 'PASSWORD'">
                <a-input ref="PASSWORD" v-decorator="[
                                        'password',
                                        { rules: [{ required: true, min: 6, message: 'Uzupełnij hasło!' }] },
                                    ]" :maxLength="128" placeholder="Hasło" type="password">
                </a-input>
              </a-form-item>
              <a-form-item v-if="step === 'FIDO'">
                <div style="text-align: center">
                  <a-icon style="font-size: 4em; color: #108ee9; margin: 2em 0em 1em 0em" type="usb"/>
                  <p>Dokończ logowanie za pomocą urządzenia uwierzytelniającego...</p>
                </div>
              </a-form-item>
              <a-form-item>
                <a-row :gutter="[8, 0]">
                  <a-col :span="12">
                    <a-button type="link" @click="step = 'FIRST_STEP'">
                      Wróć
                    </a-button>
                  </a-col>
                  <a-col :span="12" style="text-align: right;">
                    <a-button v-if="step === 'CODE'" style="margin-right: 8px;" type="link"
                              @click="clearInputCode()">
                      Wyczyść
                    </a-button>
                    <a-button :loading="loading" style="padding-left: 1.4em; padding-right: 1.4em;"
                              type="primary" @click="submit()">
                      Zaloguj
                    </a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
            <a-row :gutter="[16, 16]">
              <!-- <a-col :span="24">
                  <a-divider style="font-weight: 400; font-size: 12px">lub wybierz</a-divider>
              </a-col> -->
              <a-col :span="24">
                <a-row :gutter="[8, 0]">
                  <a-col :span="24">
                    <p style="line-height: 1.2em; margin-top: 1em;">
                      <small>
                        Loguj się tylko na zaufanym, własnym urządzeniu, aby uniknąć
                        ryzyka kradzieży
                        danych lub
                        nieuprawnionego dostępu.
                      </small>
                    </p>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-card>
        </a-spin>
      </a-col>

      <a-col :lg="10" :md="10" :sm="0" :xl="16" :xs="0" :xxl="16" style="align-self: stretch;">
        <a-card class="header" style=" height: 100%;">
          <a-row :gutter="[16, 16]" align="middle" justify="center" type="flex">
            <a-col :span="24">
              <VueLottiePlayer :animationData="require('@/assets/login.json')" :width="'auto'" loop
                               name="Server Animation"
                               style="height: 65vh; max-height: 500px;"/>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import httpClient from '../utils/httpClient';
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "Login",
  components: {
    VueLottiePlayer
  },
  data() {
    return {
      step: 'FIRST_STEP',
      loading: false,
      locked: false,
      form: this.$form.createForm(this, {name: "coordinated"}),
      codeInputs: [
        {value: null},
        {value: null},
        {value: null},
        {value: null},
        {value: null},
        {value: null},
        {value: null},
        {value: null},
      ]
    };
  },
  computed: {
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  mounted() {
    this.$emit("loadedView");
    this.focusInput();
  },
  methods: {
    submit(event) {
      if (event) event.preventDefault();
      this.form.validateFields((errors, values) => {
        if (!errors) {
          var loginData = {
            firstName: values["firstName"],
            lastName: values["lastName"],
            personId: values["personId"],
            code: this.getCodeValue(),
            password: values["password"]
          };

          this.login(loginData)
        }
      });
      return false;
    },
    login(loginData) {
      if (loginData.personId !== undefined && loginData.personId.length < 4) {
        return;
      }
      if (this.step === 'FIRST_STEP') {
        this.loading = true;
        httpClient
            .post("/identity/login/check", loginData)
            .then((response) => {
              this.step = response
            }).catch((error) => {
          if (error.response && error.response.status === 500) {
            this.$message.error("Występił błąd, spróbuj ponownie później...")
          } else if (error.response && error.response.status === 429) {
            window.location.reload();
          } else {
            this.$message.warning("Podane dane nie są prawidłowe!")
          }
        }).finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.focusInput();
          }, 1)
        });
      } else {
        if (this.step === 'CODE' && loginData.code.length !== this.codeInputs.length) {
          this.$message.warning("Uzupełnij kod logowania!")
          return;
        }
        this.loading = true;
        httpClient
            .post("/identity/login", loginData)
            .then((response) => {
              console.log("Login", response)
              window.location.href = "/home"
            }).catch((error) => {
          if (error.response && error.response.status === 500) {
            this.$message.error("Występił błąd, spróbuj ponownie później...")
          } else if (error.response && error.response.status === 429) {
            window.location.reload();
          } else {
            this.$message.warning("Podane dane nie są prawidłowe!")
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    focusInput() {
      if (this.step != 'CODE') {
        this.$refs[this.step].focus();
      } else {
        this.$refs["CODE0"][0].focus();
      }
    },
    focusNextInputCode(index) {
      if (this.codeInputs[index].value !== null && this.codeInputs[index].value) {
        this.codeInputs[index].value = this.codeInputs[index].value.toUpperCase();
      }
      if (index < this.codeInputs.length - 1) {
        this.$refs[`CODE${index + 1}`][0].focus();
        this.$refs[`CODE${index + 1}`][0].select();
      }
    },
    focusPreviousInputCode(event, index) {
      if (event.key === "Backspace" || event.key === "Delete") {
        if (index > 0) {
          if (this.codeInputs[index - 1].value == null) {
            this.codeInputs[index - 1].value = null;
          } else {
            this.codeInputs[index].value = null;
          }
          setTimeout(() => {
            this.$refs[`CODE${index - 1}`][0].focus();
            this.$refs[`CODE${index - 1}`][0].select();
          }, 1)
        } else {
          this.codeInputs[index].value = null;
        }
      }
    },
    focusOnClickInputCode(index) {
      this.$refs[`CODE${index}`][0].select();
    },
    clearInputCode() {
      for (var index = 0; index < this.codeInputs.length; index++) {
        this.codeInputs[index].value = null;
      }
      this.focusInput();
    },
    getCodeValue() {
      var code = "";
      this.codeInputs.forEach(input => {
        code += input.value
      });
      return code
    }
  }
};
</script>

<style scoped>
.header {
  background: rgb(0, 33, 61);
  background: linear-gradient(120deg, rgba(0, 22, 40, 1) 5%, rgba(25, 144, 255, 1) 200%);
  padding: 2vh 5vw;
}

@media screen and (min-width: 992px) {
  .header {
    background: rgb(0, 33, 61);
    background: linear-gradient(120deg, rgba(0, 22, 40, 1) 10%, rgba(25, 144, 255, 1) 120%);
    padding: 1vh 10vw;
  }
}

.header-text {
  font-size: 3em;
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1),
  4px 4px 0px rgba(0, 0, 75, 1),
  5px 5px 0px rgba(0, 0, 75, 1);
}

.sub-header-text {
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1);
}

.dash-after {
  margin-right: 1em;
}

.dash-after::after {
  content: '-';
  display: block;
  position: absolute;
  top: 0.15em;
  right: -0.6em;
  height: 100%;
  font-size: 1.4em;
  font-weight: 700;
  opacity: 0.6;
}
</style>